import { createSlice } from "@reduxjs/toolkit";
import { getSadminDashData } from "./Thunk";

export const sadminDash = createSlice({
  name: "sadminDash",
  initialState: {
    isLoading: false,
    dashData: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSadminDashData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getSadminDashData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.dashData = action.payload;
    });
  },
});

export const {} = sadminDash.actions;

export default sadminDash.reducer;
